/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/
// import { Dropdown } from "../reuseable";

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
import useLanguage from "../common_hooks/useLanguage";
import SearchCountingCustom from "../editor_search_import/SearchCountingCustom";
import { useState } from "react";
import Modal from "../common_modal/Modal";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
// import dict from "../../Data/dict.json";

/*CONST*/

const SET_CC = ({
  //variable
  properties,

  //function
  set_value_properties,
}) => {
  //localStorage
  const { language, dict } = useLanguage();
  
  //state & ref
  const [modal_counting_custom, set_modal_counting_custom] = useState(false)

  //global props
  const { field_editable } = properties;
  const { poi_rad, custom_counting_id } = field_editable || {};

  //variables
  const status_counting_id =
    custom_counting_id === ""
      ? "Belum Terpilih"
      : `Sudah Terpilih (${custom_counting_id})`;

  //functions
  const toggle_counting_custom = () => {
    set_modal_counting_custom(!modal_counting_custom)
  };

  const set_custom_counting_id = (data) => {
    set_value_properties({
      key: "field_editable",
      value: {
        ...field_editable,
        custom_counting_id: data,
      },
    });
  };

  const on_change = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    set_value_properties({
      key: "field_editable",
      value: {
        ...field_editable,
        [name]: value,
      },
    });
  };


  // contents
  const modalCountingCustom = modal_counting_custom && (
    <Modal
      modalSize="medium"
      id="modal_select_comparison_data"
      isOpen={modal_counting_custom}
      onClose={toggle_counting_custom}
    >
      <div className="box-body">
        <SearchCountingCustom
          toggle_counting_custom={toggle_counting_custom}
          set_custom_counting_id={set_custom_counting_id}
        />
      </div>
    </Modal>
  );

  return (
    <main>
      <h1 className="text_bold margin_bottom">Pengaturan Counting Custom</h1>

      <section
        className="container background_grey_light outline_grey"
        style={{ marginBottom: "15px", marginTop: "15px" }}
      >
        <div className="text_bold">
          {dict["Custom Counting"][language]}
        </div>
        <p>{dict?.["Select layer for counting"]?.[language]}</p>
        <p>Status : {status_counting_id}</p>

        <button
          className="button background_black"
          onClick={() => toggle_counting_custom()}
        >
          {dict?.["Open Search"]?.[language]}
        </button>
        <br />
        <br />
        <p>{dict["Set the counting radius"][language]}</p>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <input
            name="poi_rad"
            type="number"
            style={{ width: "100px", textAlign: "center" }}
            value={poi_rad}
            onChange={on_change}
          />
          <h2>meter</h2>
        </div>
      </section>

      {modalCountingCustom}
    </main>
  );
};

const mapStateToProps = (state) => ({
  // auth: state.auth,
  // layer: state.layer,
  properties: state.properties,
});

export default connect(mapStateToProps, { set_value_properties })(SET_CC);
